import SoftwaresIndex from '@/views/SoftwaresIndex.vue';
import SoftwaresCreate from '@/views/SoftwaresCreate.vue';
import SoftwaresEdit from '@/views/SoftwaresEdit.vue';

const routes = [
    {
        path: '/softwares',
        name: 'SoftwaresIndex',
        component: SoftwaresIndex,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/softwares/create',
        name: 'SoftwaresCreate',
        component: SoftwaresCreate,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/softwares/:id',
        name: 'SoftwaresEdit',
        component: SoftwaresEdit,
        meta: { layout: 'DashboardLayout' }
    }
];

export default routes
